 import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';


const ViewProductionStocks = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});
  const [totalNetWeight, setTotalNetWeight] = useState(0);

  useEffect(() => {
        setPermission(FindModuleById(453)); 
console.log(permission);

    axios
      .get(`/production-output/fetchGroupByPalletTypeData-view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.productions);
          setData(response.data.data.reports_pallet_types);
          let view =response.data.data.reports_pallet_types;
            const totalNetWeight = view.reduce((sum, item) => sum + item.net_weight, 0);
            setTotalNetWeight(totalNetWeight);

          console.log(view);

        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  
  const BarcodeCell = ({ row }) => (
    <a href={`/production-output-view/${row.original.productions_output_id}`} className="">
      {row.original.barcode_number}
    </a>
  );
  
  BarcodeCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        productions_output_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        barcode_number: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  };
  
  const CaliberCell = ({ row }) => {        
    const total_items = row.original.items || []; // Ensure it's an array
    const calibreDisplay = total_items.map(item => item.calibre).join(' / ');
  
    return <span>{calibreDisplay}</span>;
  };
  
  CaliberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        items: PropTypes.arrayOf(
          PropTypes.shape({
            calibre: PropTypes.string
          })
        )
      }).isRequired
    }).isRequired
  };
  
  const columns = [
    {
      header: 'Barcode Number',
      accessorFn: (row) => `${row.barcode_number}`,
      Cell: BarcodeCell
    },
    
    {
      accessorKey: 'product_title',
      header: 'Product',
    },
  
    {
      accessorKey: 'location_name',
      header: 'Location',
    },
  
    {
      accessorKey: 'number_of_boxes',
      header: 'Number Of Boxes',
    },
  
    {
      accessorKey: 'lot_number',
      header: 'Lot Number',
    },
    // {
    //   accessorKey: 'gross_weight',
    //   header: 'Gross Weight',
    // },
    // {
    //   accessorKey: 'net_weight',
    //   header: 'Net Weight',
    // }, 
     {
      header: 'Gross Weight',
      accessorFn: (row) => {
        const netWeight = row.gross_weight ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },
     {
      header: 'Net Weight',
      accessorFn: (row) => {
        const netWeight = row.net_weight ?? 0; // Default to 0 if undefined or null
        return `${Number(netWeight).toFixed(2)} (KG)`;
      },
    },
  

  ];

  console.log(value);
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Group By Product And Location</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-stocks">Production Stocks</Link>
                    </li>
                    <li className="breadcrumb-item active">
                       Production Group By Product And Location
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          
            <div className="row">
                
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Product </div>
                          <div className="dash-counts">
                                  <p>{data.length > 0 ? data[0].product_title : "No data available"}</p>

                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Location</div>
                          <div className="dash-counts">
                          <p>{data.length > 0 ? data[0].location_name : "No data available"}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
              
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Total Net Weight</div>
                          <div className="dash-counts">
                          <p>{totalNetWeight}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
            
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Listing Productions Output</h4>
                    <div className="table-responsive">
                        <MaterialReactTable columns={columns} data={data} 
                          enableColumnOrdering
                          enablePinning
                          enableRowActions
                          
                        />
                      </div>
                  </div>
                </div>
              </div>
            </div>
         
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewProductionStocks;
